import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { FiSearch, FiEye, FiEdit, FiTrash2, FiPlus, FiMinus, AiOutlineClose } from 'react-icons/fi'; // Using react-icons library
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Import the CSS for toast notifications
import { FiChevronDown, FiChevronUp, } from 'react-icons/fi';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { AiOutlineClose as CloseIcon } from 'react-icons/ai';
import { GetKeyLogs, AddKeyLog, UpdateKeyLog, GetAllKey, GetEmployee, GetDepartment } from '../../services/Api';
import "./keyRegister.css"
import { FaFileExcel } from 'react-icons/fa';
import { FiDownload } from 'react-icons/fi';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
// Your existing code...

import { format } from 'date-fns';


const Container = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
`;
const StyledDatePicker = styled(DatePicker)`
  width: 100%;
  padding: 8px 0;
  border: none;
  border-bottom: 2px solid ${props => (props.$hasError ? 'red' : '#2B3497')};
  font-family: 'Segoe UI', Regular;
  background: transparent;

  &:focus {
    outline: none;
    border-bottom: 2px solid ${props => (props.$hasError ? 'red' : '#2B3497')};
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
`;

const Heading = styled.h1`
  font-size: 24px;
  font-family: 'Segoe UI', 'Semibold';
      color:#2B3497;
`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 10px #00000029;
  border-radius: 8px;
  padding: 7px;
  width: 248px;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 16px;
  padding: 5px;
  flex: 1;
`;

const SearchIcon = styled(FiSearch)`
  margin-right: 10px;
  color: #000;
`;
// const Input = styled.input`
//   width: 100%;
//   padding: 8px 0;
//   border: none;
//   border-bottom: 1px solid #2B3497;
//   font-family: 'Segoe UI', 'Regular';
//   margin-top:10px;
//   background: transparent;
//   &:focus {
//     outline: none;
//     border-bottom: 2px solid #2B3497;
//   }
// `;


const Card = styled.div`
  background-color: #f5f5f5;
  box-shadow: 0px 5px 10px #00000038;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  padding: 10px 20px;
  font-size: 16px;
  font-family: 'Segoe UI', 'Semibold';
  border-radius: 27px;
  opacity: 1;
  color: #fff;

  &.add-location {
    background-color: #293495;
  }

  &.reset {
    background-color: red;
    border-radius: 12px;
    box-shadow: 0px 10px 20px #2b349752;
  }

  &.submit {
    background-color: #3d46b4;
    border-radius: 12px;
    box-shadow: 0px 10px 20px #2b349752;
  }

  & > svg {
    margin-left: 8px;
  }
`;

const LocationInput = styled.input`
  border: none;
  border-bottom: 2px solid #3d46b4;
  outline: none;
  font-size: 16px;
  padding: 10px;
  margin-left: 20px;
  width: 200px;
  background: transparent;
`;

const TableContainer = styled.div`
  margin-top: 20px;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: linear-gradient(to right, #e6e6e6, #f2f2f2, #f5f5f5, #f3f3f3, #e9e9e9);
  box-shadow: 0px 10px 20px #0000001a;
  border-radius: 10px;
`;

const TableHeader = styled.th`
  background-color: #e6e6e6;
  color: #000;
  padding: 10px;
  text-align: left;
      cursor: pointer;

`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f5f5f5;
  }

  &:hover {
    background-color: #d9d9d9;
  }
`;

const TableCell = styled.td`
  padding: 10px;
  text-align: left;
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
`;

const PaginationButton = styled.button`
  background-color: #3d46b4;
  color: #fff;
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #293495;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const DropdownSelect = styled.select`
  border: none;
  border-bottom: 2px solid ${props => (props.hasError ? 'red' : '#293495')};
  padding: 8px 5px;
  font-size: 14px;
  outline: none;
  background: transparent;
  background-image: url('data:image/svg+xml;utf8,<svg fill="none" stroke="${props =>
    props.hasError ? 'red' : '%23293495'}" stroke-width="2" viewBox="0 0 24 24"><path d="M19 9l-7 7-7-7"/></svg>');
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px 16px;
  cursor: pointer;

  &:focus {
    border-bottom: 2px solid ${props => (props.hasError ? 'red' : '#1a237e')};
  }
`;

const IconWrapper = styled.span`
  cursor: pointer;
  color: #2B3497;
  margin: 0 5px;
`;
const Popup = styled.div`
  position: fixed;
  top: 50%;
  left: 55%;
  transform: translate(-50%, -50%);
  background: linear-gradient(#FFFFFF, #F5F5F5, #FFFFFF);
  box-shadow: 0px 0px 1px #0000004A;
  border-radius: 30px;
  padding: 30px;
  text-align: center;
  opacity: 1;
  z-index: 1000;
  width: 500px;
  height: auto; /* Use auto height to fit content */
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Push content and buttons to the top/bottom */
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end; /* Align buttons to the right */
  margin-top: 20px; /* Add some space between content and buttons */
`;

const PopupButton = styled.button`
  background-color: #2B3397;
  color: #fff;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  box-shadow: 0px 10px 20px #2B349754;
  opacity: 1;
  cursor: pointer;
  margin-left: 10px; /* Add space between buttons */
`;

const PopupText = styled.p`
  font-size: 18px;
  color: #2B3497;
  margin-bottom: 20px;
`;
const LabelValueContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

const Value = styled.span`
  font-size: 16px;
  color: #000;
  width: 55%; /* Control value width */
  text-align: right; /* Ensure value is aligned to the right */
`;
const ModalContainer = styled.div`
position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  padding: 29px;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  z-index: 1000;
  width: 80%;
  max-width: 800px;
  display: flex;
  flex-direction: column;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const ModalTitle = styled.h2`
  color: #293495;
  font-size: 20px;
  font-weight: bold;
  margin: 0;
`;


const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const InputFieldFull = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const FlexRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
`;

const InputFieldHalf = styled.div`
  flex: 0 0 48%;
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  margin-bottom: 5px;
  font-weight: 600;
  color: #000;
`;

const LabelN = styled.label`
  font-weight: 500;
  margin-bottom: 5px;
  color: #000;
`;

const Input = styled.input`
  width: 100%;
  padding: 8px 0;
  border: none;
  border-bottom: 2px solid ${props => (props.hasError ? 'red' : '#2B3497')};
  font-family: 'Segoe UI', 'Regular';
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid ${props => (props.hasError ? 'red' : '#2B3497')};
  }
`;

const Checkbox = styled.input`
  transform: scale(1.2);
  margin-top: 5px;
`;

const SubmitButton = styled.button`
  margin-top: 20px;
  background-color: #293495;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  float: right;
  cursor: pointer;

  &:hover {
    background-color: #1f2970;
  }
`;
const FileUploadContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const HiddenFileInput = styled.input`
  display: none;
`;

const CustomFileButton = styled.button`
  background-color: #293495;
  color: #ffffff;
  padding: 8px 16px;
  font-size: 14px;
  font-family: 'Segoe UI', Semibold;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    background-color: #1f2875;
  }
`;

const FileNameInput = styled.input`
  flex: 1;
  padding: 8px;
  border: none;
  border-bottom: 1px solid #2b3497;
  font-family: 'Segoe UI', Regular;
  background: transparent;
  color: #000;

  &:focus {
    outline: none;
    border-bottom: 2px solid #2b3497;
  }
`;
const ResetButton = styled.button`
  background-color: red;
margin-top: 20px;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  float: right;
  cursor: pointer;

  &:hover {
    background-color: darkred;
  }
`;
const Asterisk = styled.span`
  color: red;
`;


const DropdownContainerTwo = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const ExportIcon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 10px;
  color: #293495;


  // &:hover {
  //   color: #293495;
  // }
`;

// Styling for the custom options panel
const OptionsPanel = styled.div`
  position: absolute;
  top: 30px;
  right: 0;
  background-color: #f9f9f9;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 150px;
  z-index: 10;
`;

// Individual option items
const OptionItem = styled.div`
  padding: 10px;
  cursor: pointer;
  text-align: left;
  &:hover {
    background-color: #f1f1f1;
  }
`;



const AddEntityPage = () => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortColumn, setSortColumn] = useState('');
  const [sortDirection, setSortDirection] = useState('asc');
  const [departments, setDepartments] = useState([]);

  const [formValues, setFormValues] = useState({
    keyID: '',
    issuedToID: '',
    issuedDateTime: '',
    returnedDateTime: ''
  });


  // Sort function
  const [allKeys, setAllKeys] = useState([]);
  const [allEmployee, setAllEmployee] = useState([]);

  const rowsPerPage = 5;
  const today = new Date().toISOString().split('T')[0];

  const [keyLogDate, setKeyLogDate] = useState(() => {
    const today = new Date().toISOString().split('T')[0];
    return today;
  });
  const [shouldBeReturned, setShouldBeReturned] = useState(false);

  const [keyLogs, setKeyLogs] = useState([]);

  // Fetch key logs for the selected date

  // Fetch key logs based on return status and date
  const fetchKeyLogs = async (returned, date) => {
    try {
      const params = returned
        ? { toBeReturned: true }
        : { dateTime: date, toBeReturned: false };

      const response = await axios.get('/KeyLog/GetKeyLogsData', { params });
      setKeyLogs(response?.data?.TableData || []);
    } catch (error) {
      console.error("Failed to fetch key logs:", error);
    }
  };


  // ⏱ On initial page load, if checkbox is checked
  useEffect(() => {
    if (shouldBeReturned) {
      fetchKeyLogs(true);
    }
  }, []);

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setShouldBeReturned(isChecked);

    if (isChecked) {
      fetchKeyLogs(true);
    } else {
      fetchKeyLogs(false, keyLogDate);
    }
  };

  useEffect(() => {
    if (!shouldBeReturned && keyLogDate) {
      fetchKeyLogs(false, keyLogDate);
    }
  }, [keyLogDate]);



  // Fetch key logs for the selected date
  const fetchAllKeys = async () => {
    try {
      const response = await GetAllKey();
      setAllKeys(response || []);
    } catch (error) {
      console.error("Failed to fetch All keys:", error);
    }
  };

  // Fetch key logs for the selected date
  const fetchEmployee = async () => {
    try {
      const response = await GetEmployee();
      setAllEmployee(response || []);
    } catch (error) {
      console.error("Failed to fetch All Employees:", error);
    }
  };
  const fetchDepartment = async () => {
    try {
      const response = await GetDepartment();
      setDepartments(response);
    } catch (error) {
      console.error('Error fetching Courers name:', error);
    }
  }



  useEffect(() => {
    fetchDepartment();
    fetchAllKeys();
    fetchEmployee();
  }, []);
  const sortData = (data, column, direction) => {
    const sortedData = [...data].sort((a, b) => {
      if (direction === 'asc') {
        return a[column] > b[column] ? 1 : -1;
      } else {
        return a[column] < b[column] ? 1 : -1;
      }
    });
    return sortedData;
  };

  // const handleSort = (column) => {
  //   const direction = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
  //   setSortColumn(column);
  //   setSortDirection(direction);
  //   const sortedData = sortData(data, column, direction);
  //   setData(sortedData);
  // };


  const handleAddLocationClick = () => {
    handleReset();
    setIsModalOpen(true)
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setIsEditing(false);
    setErrors({});
  }

  // const handleEdit = (location) => {
  // }

  // const handleDelete = (id) => {
  //   confirmAlert({
  //     title: <span style={{ color: '#dc3545' }}>Warning</span>,
  //     message: 'Are you sure you want to delete this location?',
  //     buttons: [
  //       {
  //         label: 'Yes',
  //         onClick: async () => {
  //           try {
  //             // Sending the PUT request to mark the location as deleted
  //             await axios.put('/Location', {
  //               id: id,
  //               locationName: locations.find(location => location.id === id)?.locationName,
  //               isDeleted: true
  //             });

  //             // Update the local state to remove the deleted location from the UI
  //             setLocations((prevData) => prevData.filter(location => location.id !== id));

  //             // Show success toast message
  //             toast.success('Location Deleted Successfully');
  //           } catch (error) {
  //             console.error('Error deleting location:', error);
  //             // Show error toast message
  //             toast.error('Failed to Delete Location');
  //           }
  //         }
  //       },
  //       {
  //         label: 'No',
  //         onClick: () => {
  //           // Close dialog without taking any action
  //         }
  //       }
  //     ]
  //   });
  // const handleCloseModal = () => setIsModalOpen(false);


  // const handleEdit = (location) => {
  //   console.log('location Data', location);
  // };


  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page when searching
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const filteredData = data.filter(row =>
    String(row.KeyID || '').toLowerCase().includes(searchTerm?.toLowerCase() ?? '')
  );

  // Filtered key logs
  const filteredLogs = Array.isArray(keyLogs)
    ? keyLogs.filter(item => {
      const term = searchTerm?.toLowerCase().trim();
      if (!term) return true;

      const excludeKeys = ['CreatedBy', 'CreatedOn', 'ModifiedBy', 'ModifiedOn'];

      return Object.entries(item).some(([key, value]) =>
        !excludeKeys.includes(key) &&
        String(value ?? '').toLowerCase().includes(term)
      );
    })
    : [];

  // Pagination logic
  const itemsPerPage = 5;
  const totalItems = filteredLogs.length;
  const maxPage = Math.max(1, Math.ceil(totalItems / itemsPerPage));
  const safeCurrentPage = Math.min(currentPage, maxPage);
  const indexOfLastItem = safeCurrentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredLogs.slice(indexOfFirstItem, indexOfLastItem);




  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const totalPages = Math.ceil(filteredLogs.length / rowsPerPage);

  const handlePageChange = (event) => {
    setCurrentPage(Number(event.target.value));
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const currentRows = filteredLogs.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const totalPageNumbers = Math.min(totalPages, 10); // Show up to 10 page numbers

    let startPage = Math.max(currentPage - 5, 1);
    let endPage = Math.min(startPage + totalPageNumbers - 1, totalPages);

    // Adjust startPage if endPage exceeds totalPages
    if (endPage === totalPages) {
      startPage = Math.max(totalPages - totalPageNumbers + 1, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <PaginationButton
          key={i}
          className={currentPage === i ? 'active' : ''}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </PaginationButton>
      );
    }

    return pageNumbers;
  };
  const [isExpanded, setIsExpanded] = useState(true);
  const toggleExpandCollapse = () => {
    setIsExpanded(!isExpanded);
  };

  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [popupData, setPopupData] = useState('');

  const closePopup = () => {
    setIsPopupVisible(false);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);


  const [uploadDocs, setUploadDocs] = useState(false);
  const [uploadNDA, setUploadNDA] = useState(false);
  const [uploadTraining, setUploadTraining] = useState(false);
  const [uploadSafety, setUploadSafety] = useState(false);
  const [documentFile, setDocumentFile] = useState('');
  const [ndaFile, setNdaFile] = useState('');
  const handleReset = () => {
    setUploadDocs(false);
    setUploadNDA(false);
    setUploadTraining(false);
    setUploadSafety(false);
    setDocumentFile('');
    setNdaFile('');

    if (isEditing) {
      // In edit mode, only clear returnedDateTime
      setFormData(prev => ({
        ...prev,
        returnedDateTime: prev.returnedDateTime
          ? prev.returnedDateTime
          : getLocalDateTimeForInput()
      }));
    } else {
      // Full reset when not editing
      setFormData({
        keyId: '',
        keyName: '',
        issuedToId: '',
        issuedDateTime: getLocalDateTimeForInput(),
        returnedDateTime: null, // Default is null
        returnedStatus: '',   // Default is empty string
        remarks: '',
        departmentId: '',
        Department: '',        // Default is empty string
        KeyNumber: ''
      });
    }
  };

  function getLocalDateTimeForInput() {
    const now = new Date();
    const pad = (n) => n.toString().padStart(2, '0');

    const year = now.getFullYear();
    const month = pad(now.getMonth() + 1);
    const day = pad(now.getDate());
    const hours = pad(now.getHours());
    const minutes = pad(now.getMinutes());

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }


  const [formData, setFormData] = useState({
    keyId: '',
    keyName: '',
    issuedToId: '',
    issuedDateTime: '',  // initially empty
    returnedDateTime: '',
    returnedStatus: '',
    remarks: '',
    departmentId: '',
    Department: '',
    KeyNumber: ''
  });

  console.log(formData);

  // useEffect(() => {
  //   if (!formData.issuedDateTime) {
  //     setFormData((prev) => ({
  //       ...prev,
  //       issuedDateTime: getLocalDateTimeForInput()
  //     }));
  //   }
  // }, []);



  const [isEditing, setIsEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [errors, setErrors] = useState({});

  const handleSort = (column) => {
    const newDirection = sortColumn === column && sortDirection === "asc" ? "desc" : "asc";
    setSortColumn(column);
    setSortDirection(newDirection);

    console.log("keys logs", keyLogs);

    const sortedData = [...keyLogs].sort((a, b) => {
      let valA = a[column];
      let valB = b[column];

      if (column.includes("DateTime")) {
        valA = new Date(valA);
        valB = new Date(valB);
      }

      if (valA < valB) return newDirection === "asc" ? -1 : 1;
      if (valA > valB) return newDirection === "asc" ? 1 : -1;
      return 0;
    });

    setKeyLogs(sortedData);
  };


  const handleSubmit = async () => {

    const newErrors = {};

    if (!formData.keyId) newErrors.keyId = 'Key is required.';
    if (!formData.issuedToId) newErrors.issuedToId = 'Employee is required.';
    if (!formData.issuedDateTime) newErrors.issuedDateTime = 'Issued datetime is required.';
    if (!String(formData.departmentId).trim()) newErrors.departmentId = 'Department is required.';

    // if (!formData.returnedDateTime) newErrors.returnedDateTime = 'Returned datetime is required.';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      toast.error("Please fix the required fields.");
      return;
    }


    try {
      if (isEditing) {
        const response = await UpdateKeyLog({ ...formData, id: editingId, });
        console.log("form data", response);
        toast.success(response?.res_message || 'Key Management updated successfully!');
      } else {
        const response = await AddKeyLog(formData);
        console.log("form data", response);
        if(response?.res_message == "Already key assigned."){
          toast.error('Already key assigned.');

        }else {
          toast.success(response?.res_message || 'Key Management added successfully!');

        }
      }

      // Reset form & refresh data
      setFormData({
        keyId: '',
        keyName: '',
        issuedToId: '',
        issuedDateTime: '',
        returnedDateTime: null, // Default is null
        returnedStatus: '',   // Default is empty string
        remarks: '',         // Default is empty string
        KeyNumber: '',
        departmentId: '',
        Department: '',
      });
      setIsEditing(false);
      setEditingId(null);
      setIsModalOpen(false);
      if (shouldBeReturned) {
        fetchKeyLogs(true);
      }  
      else{
        fetchKeyLogs(false, keyLogDate);

      }    
      
      setErrors({});
    } catch (err) {
      console.log(err?.response?.data?.title);
      toast.error(isEditing ? err?.response?.data?.title || 'Failed to update key.' : err?.response?.data?.title || 'Failed to add key.');
      console.error(err);
    }
  };

  const handleEdit = (row) => {
    setFormData({
      keyId: row.KeyID,
      keyName: row.KeyName, // For input type="datetime-local"
      issuedToId: row.IssuedToID,
      issuedDateTime: row.IssuedDateTime,
      returnedDateTime: row.ReturnedDateTime ? row.ReturnedDateTime : getLocalDateTimeForInput(),
      returnedStatus: row.ReturnedStatus,
      remarks: row.Remarks,
      departmentId: row.DepartmentID,
      Department: row.Department,
      KeyNumber: row.Remarks
    });
    setEditingId(row.Id); // or row.courierId based on your backend
    setIsEditing(true);
    setIsModalOpen(true);

    // clear errors
    setErrors({});
  };
  const [isPanelOpen, setIsPanelOpen] = useState(false);

  // Function to toggle the export options panel
  const togglePanel = () => {
    setIsPanelOpen((prevState) => !prevState);
  };

  const handleExportOptionClick = (format) => {
    if (filteredLogs.length === 0) {
      toast.warning('No data available to export.');
      return;
    }
    if (format === 'excel') {
      exportToExcel(); // Call the Excel export function
    } else if (format === 'pdf') {
      exportToPDF(); // Call the PDF export function
    }

    // Close the panel after making a selection
    setIsPanelOpen(false);
  };

  const exportToExcel = () => {
    const filteredDataNee = filteredLogs.map((row) => ({
      KeyName: row.KeyName,
      KeyNumber: row.KeyNumber,
      IssuedTo: row.IssuedToName,
      Department: row.DeptDescription,
      IssueDatetime: row.IssuedDateTime,
      ReturnDatetime: row.ReturnedDateTime,
      returnedStatus: row.ReturnedStatus,
      remarks: row.Remarks,

    }));
    const worksheet = XLSX.utils.json_to_sheet(filteredDataNee);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Key Register Reports');

    // Adjust column widths for better alignment
    worksheet['!cols'] = [
      { wpx: 150 }, // Visitor Name
      { wpx: 150 }, // Visitor Mobile
      { wpx: 150 }, // Visitor Mobile
      { wpx: 200 }, // Visitor Company
    ];

    XLSX.writeFile(workbook, 'Key_Register_Report.xlsx');
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const header = () => {
      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");

      // Left Header Text
      doc.text("SecoreX - Visitor Management System", 14, 10);

      // Horizontal Line (Header bottom border)
      doc.setDrawColor(0); // Black color
      doc.setLineWidth(0.5);
      doc.line(14, 12, pageWidth - 14, 12);

      // Center Title below the line
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      doc.text("Key Register Reports", pageWidth / 2, 22, { align: "center" });

      doc.setFontSize(10); // Reset for table content
    };

    const footer = (data) => {
      const pageCount = doc.internal.getNumberOfPages();
      const currentPage = data.pageNumber;

      // Footer Line
      doc.setDrawColor(0);
      doc.line(14, pageHeight - 15, pageWidth - 14, pageHeight - 15);

      // Left Footer Text
      doc.text("Key Reports", 14, pageHeight - 10);

      // Right Footer Text (Page X of Y)
      const pageText = `Page ${currentPage} of ${pageCount}`;
      const textWidth = doc.getTextWidth(pageText);
      doc.text(pageText, pageWidth - textWidth - 14, pageHeight - 10);
    };
    doc.autoTable({
      head: [
        ['Key Name', 'Key Number', 'Issued To', 'Department', 'Issue Datetime', 'Return Datetime', 'Returned Status', 'Remarks']
      ],
      body: filteredLogs.map((row) => [
        row.KeyName,
        row.KeyNumber,
        row.IssuedToName,
        row.DeptDescription,
        row.IssuedDateTime,
        row.ReturnedDateTime,
        row.ReturnedStatus,
        row.Remarks,
      ]),
      startY: 30,
      theme: 'grid',
      didDrawPage: function (data) {
        header(data);
        footer(data);
      },
      margin: { top: 35 },

    });
    doc.save('Key_Register.pdf');
  };
  function getLocalDateTimeForInput() {
    const now = new Date();
    const offset = now.getTimezoneOffset();
    const local = new Date(now.getTime() - offset * 60000);
    return local.toISOString().slice(0, 16); // "YYYY-MM-DDTHH:MM"
  }

  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsPanelOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);


  return (
    <Container>
      <Header>
        <Heading>Key Register</Heading>
        <div style={{ display: 'flex', alignItems: 'center' }}>

          <SearchBox>
            <SearchIcon size={20} />
            <SearchInput
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleSearch}
            />
          </SearchBox>
          <DropdownContainerTwo ref={dropdownRef}>
            <ExportIcon onClick={togglePanel} title="Export">
              <FiDownload size={25} />
            </ExportIcon>
            {/* Show the panel with options if isPanelOpen is true */}
            {isPanelOpen && (
              <OptionsPanel>
                <OptionItem onClick={() => handleExportOptionClick('excel')}>Excel</OptionItem>
                <OptionItem onClick={() => handleExportOptionClick('pdf')}>PDF</OptionItem>
              </OptionsPanel>
            )}
          </DropdownContainerTwo>
        </div>
      </Header>
      <Card>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <Button className="add-location" onClick={handleAddLocationClick}>
            Issue <FiPlus size={20} />
          </Button>
          <button
            onClick={() => {
              const newValue = !shouldBeReturned;
              setShouldBeReturned(newValue);
              if (newValue) {
                fetchKeyLogs(true);
              } else {
                fetchKeyLogs(false, keyLogDate);
              }
            }}
            style={{
              padding: '12px 16px',
              border: '1px solid #293495',
              borderRadius: '27px',
              fontWeight: '400',
              backgroundColor: shouldBeReturned ? '#293495' : 'transparent',
              color: shouldBeReturned ? '#fff' : '#293495',
              cursor: 'pointer',
            }}
          >
            {shouldBeReturned ? 'Return' : 'Return'}
          </button>

        </div>

        <div style={{ display: 'flex', alignItems: "baseline" }}>
          <Label style={{ whiteSpace: "nowrap" }}>Date : </Label>
          <Input
            type="date"
            required
            value={keyLogDate}
            onChange={(e) => setKeyLogDate(e.target.value)}
            style={{ padding: '6.5px 5px' }}
            disabled={shouldBeReturned}
          />
        </div>
      </Card>
      <TableContainer>
        <StyledTable>
          <thead>
            <tr>
              <TableHeader colSpan={'9'} style={{ backgroundColor: "rgb(24, 62, 159)", color: "#fff" }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ textAlign: 'center', flex: '1', color: "#fff" }}>Key Management Details</span>
                  <IconWrapper onClick={toggleExpandCollapse} style={{ cursor: 'pointer', color: "#fff" }}>
                    {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
                  </IconWrapper>
                </div>
              </TableHeader>
            </tr>
          </thead>
          {isExpanded && (
            <>
              <thead>
                <tr>
                  {/* <TableHeader onClick={() => handleSort('ioNumber')}>ID Number {sortColumn === 'ioNumber' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader> */}
                  <TableHeader onClick={() => handleSort('KeyName')}>Key Name {sortColumn === 'KeyName' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  <TableHeader onClick={() => handleSort('KeyNumber')}>
                    Key Number {sortColumn === 'KeyNumber' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </TableHeader>
                  <TableHeader onClick={() => handleSort('IssuedToName')}>Issued To{sortColumn === 'IssuedToName' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  <TableHeader onClick={() => handleSort('DeptDescription')}>
                    Department {sortColumn === 'DeptDescription' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </TableHeader>
                  <TableHeader onClick={() => handleSort('IssuedDateTime')}> Issue Datetime  {sortColumn === 'IssuedDateTime' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  <TableHeader onClick={() => handleSort('ReturnedDateTime')}>Return Datetime {sortColumn === 'ReturnedDateTime' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  <TableHeader onClick={() => handleSort('ReturnedStatus')}>
                    Returned Status {sortColumn === 'ReturnedStatus' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </TableHeader>
                  <TableHeader onClick={() => handleSort('Remarks')}>
                    Remarks {sortColumn === 'Remarks' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </TableHeader>
                  {/* <TableHeader onClick={() => handleSort('status')}>Status {sortColumn === 'status' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader> */}
                  <TableHeader>Return</TableHeader>
                </tr >
              </thead >
              <tbody>

                {
                  currentItems && currentItems.length > 0 ? (
                    currentItems.map((row, idx) => (
                      <TableRow key={idx}>
                        {/* <TableCell>{row.KeyID}</TableCell> */}
                        <TableCell>{row.KeyName}</TableCell>
                        <TableCell>{row.KeyNumber ?? '-'}</TableCell>
                        <TableCell>{row.IssuedToName}</TableCell>
                        <TableCell>{row.DeptDescription}</TableCell>
                        <TableCell>{row.IssuedDateTime ? (() => {
                          const date = new Date(row.IssuedDateTime);
                          const day = String(date.getDate()).padStart(2, '0');
                          const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
                          const year = date.getFullYear();
                          const hours = String(date.getHours()).padStart(2, '0');
                          const minutes = String(date.getMinutes()).padStart(2, '0');

                          return `${day}-${month}-${year} ${hours}:${minutes}`;
                        })() : '-'}</TableCell>
                        <TableCell>{row.ReturnedDateTime ? (() => {
                          const date = new Date(row.ReturnedDateTime);
                          const day = String(date.getDate()).padStart(2, '0');
                          const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
                          const year = date.getFullYear();
                          const hours = String(date.getHours()).padStart(2, '0');
                          const minutes = String(date.getMinutes()).padStart(2, '0');

                          return `${day}-${month}-${year} ${hours}:${minutes}`;
                        })() : '-'}</TableCell>
                        <TableCell>{row.ReturnedStatus ?? '-'}</TableCell>
                        <TableCell>{row.Remarks ?? '-'}</TableCell>
                        <TableCell>
                          <IconWrapper onClick={() => handleEdit(row)}>
                            <FiEdit />
                          </IconWrapper>
                          {/* Uncomment if delete is needed */}
                          {/* <IconWrapper onClick={() => handleDelete(row.id)}>
          <FiTrash2 />
        </IconWrapper> */}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={8} style={{ textAlign: 'center', padding: '20px' }}>No key logs available.</TableCell>
                    </TableRow>
                  )}
              </tbody>
            </>
          )
          }
        </StyledTable >
        {isExpanded && (
          <>
            <PaginationContainer>
              <PaginationButton onClick={handlePrevPage} disabled={currentPage === 1}>
                Previous
              </PaginationButton>

              <DropdownSelect value={currentPage} onChange={handlePageChange}>
                {Array.from({ length: totalPages }, (_, i) => (
                  <option key={i + 1} value={i + 1}>
                    Page {i + 1}
                  </option>
                ))}
              </DropdownSelect>

              <PaginationButton onClick={handleNextPage} disabled={currentPage === totalPages}>
                Next
              </PaginationButton>
            </PaginationContainer>
          </>
        )}
        {
          isModalOpen && (
            <ModalContainer>
              <ModalHeader>
                <ModalTitle>{isEditing ? "Return Key" : "Issue Key"}</ModalTitle>
                <CloseIcon size={24} onClick={handleCloseModal} />
              </ModalHeader>

              <InputGroup>
                <InputFieldFull>
                  <Label>Key Name <Asterisk>*</Asterisk></Label>
                  <DropdownSelect
                    required
                    disabled={isEditing} // disable in edit mode
                    value={formData.keyId}
                    hasError={!!errors.keyId}
                    onChange={(e) =>
                      setFormData({ ...formData, keyId: e.target.value })
                    }
                  >
                    <option value="">Select Key</option>
                    {allKeys
                      .filter((key) => key.keyName?.trim()) // only show keys with names
                      .map((key) => (
                        <option key={key.id} value={key.id}>
                          {key.keyName}
                        </option>
                      ))}
                  </DropdownSelect>
                  {/* {errors.keyId && <span className="error">{errors.keyId}</span>} */}

                </InputFieldFull>


                <InputFieldFull>
                  <Label>Issue To <Asterisk>*</Asterisk></Label>
                  <DropdownSelect
                    required
                    disabled={isEditing} // disable in edit mode
                    value={formData.issuedToId}
                    hasError={!!errors.issuedToId}
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      const selectedEmp = allEmployee.find(emp => emp.id === parseInt(selectedId));

                      setFormData({
                        ...formData,
                        issuedToId: selectedId,
                        departmentId: selectedEmp ? selectedEmp.departmentId : '', // Auto-populate department
                      });
                    }}
                    className={`w-full p-2 border ${errors.issuedToId ? 'border-red-500' : 'border-gray-300'} rounded`}

                  >
                    <option value="">Select Employee</option>
                    {allEmployee
                      .filter(emp => emp.employeeName?.trim())
                      .map((emp) => (
                        <option key={emp.id} value={emp.id}>
                          {emp.employeeName}
                        </option>
                      ))}
                  </DropdownSelect>
                  {/* {errors.issuedToId && <span className="error">{errors.issuedToId}</span>} */}
                </InputFieldFull >
                <InputFieldFull>
                  <Label>Department <Asterisk>*</Asterisk></Label>
                  <DropdownSelect
                    required
                    value={formData.departmentId}
                    hasError={!!errors.departmentId}

                    onChange={(e) =>
                      setFormData({ ...formData, departmentId: e.target.value })
                    }
                  >
                    <option value="">Select Department</option>
                    {departments
                      .filter((dept) => !dept.isDeleted)
                      .map((dept) => (
                        <option key={dept.id} value={dept.id}>
                          {dept.deptDescription}
                        </option>
                      ))}
                  </DropdownSelect>
                  {/* {errors.issuedToId && <span className="error">{errors.issuedToId}</span>} */}
                </InputFieldFull >


                <FlexRow>
                  <InputFieldHalf>
                    <Label>Issue Datetime <Asterisk>*</Asterisk> </Label>
                    <StyledDatePicker
                      selected={formData.issuedDateTime ? new Date(formData.issuedDateTime) : null}
                      onChange={(date) => {
                        const formatted = format(date, "yyyy-MM-dd'T'HH:mm");
                        setFormData({ ...formData, issuedDateTime: formatted });
                      }}
                      showTimeSelect
                      timeIntervals={1}
                      dateFormat="dd-MM-yyyy h:mm aa"
                      maxDate={new Date()}
                      maxTime={new Date()}
                      placeholderText="Select date and time"
                      disabled={isEditing}
                      $hasError={!!errors.issuedDateTime}
                    />

                    {/* {errors.issuedDateTime && <span className="error">{errors.issuedDateTime}</span>} */}

                  </InputFieldHalf >

                  <InputFieldHalf>
                    <Label>Return Datetime<Asterisk></Asterisk></Label>
                    <Input
                      type="datetime-local"
                      required
                      disabled={!isEditing}
                      value={formData.returnedDateTime}
                      min={
                        new Date(
                          new Date(formData.issuedDateTime || new Date()).getTime() + 60 * 1000
                        )
                          .toISOString()
                          .slice(0, 16) // Format for datetime-local input
                      }
                      onChange={(e) =>
                        setFormData({ ...formData, returnedDateTime: e.target.value })
                      }
                    />


                    {/* {errors.returnedDateTime && <span className="error">{errors.returnedDateTime}</span>} */}
                  </InputFieldHalf >
                </FlexRow >

                <FlexRow>
                  <InputFieldHalf>
                    <Label>Returned Status<Asterisk></Asterisk></Label>
                    <Input
                      type="text"
                      placeholder="Enter Returned Status"
                      required
                      maxLength={50}
                      value={formData.returnedStatus}
                      //  hasError={!!errors.returnedStatus}
                      onChange={(e) => {
                        const value = e.target.value;
                        const cleanedValue = value.replace(/[^a-zA-Z0-9\s]/g, ''); // letters, numbers, spaces only
                        setFormData({ ...formData, returnedStatus: cleanedValue });
                      }}
                    />
                  </InputFieldHalf>
                  <InputFieldHalf>
                    <Label>Remarks<Asterisk></Asterisk></Label>
                    <Input
                      type="text"
                      placeholder="Enter Remarks"
                      required
                      maxLength={50}
                      value={formData.remarks}

                      //hasError={!!errors.remarks}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^a-zA-Z0-9 ]/g, '');
                        setFormData({ ...formData, remarks: value });
                      }}
                    />

                  </InputFieldHalf>

                </FlexRow>

              </InputGroup >

              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
                <ResetButton onClick={handleReset}>Reset</ResetButton>
                <SubmitButton onClick={() => {
                  handleSubmit();
                }
                }>Submit</SubmitButton>
              </div >
            </ModalContainer >
          )
        }


      </TableContainer >
      <ToastContainer />

    </Container >
  );
};

export default AddEntityPage;
